import {
  TAuditDetailsByEventName,
  TAuditEventName,
  TAuditOriginName,
} from './audit-trail.model';

/**
 * Ajustes › Auditoria (personservice `GET /OData/AuditEvents`, feature 003 F5).
 *
 * `AuditEventView` 1:1. OData sends enums by NAME, so `Event` and `Origin`
 * are name unions (see `audit-trail.model.ts`). `Details` is JSON TEXT here —
 * on the timeline it is an object — and `AuditEventStore.rows` parses it.
 */
export type TAuditEventView = {
  AuditEventId: string;
  TenantId: string;
  PersonId: string | null;
  PersonName: string | null;
  Event: TAuditEventName;
  EventName: string;
  /** Brasília wall time, the indexed column: the period filters on it. */
  OccurredOn: string;
  /** The instant, for display. */
  OccurredOnUtc: string;
  UserId: string | null;
  UserName: string | null;
  /** System event: show `ResponsibleByName` ("Sistema · regra salva por …"). */
  IsSystem: boolean;
  ResponsibleBy: string | null;
  ResponsibleByName: string | null;
  /** `null` on rule saves, which have no origin. */
  Origin: TAuditOriginName | null;
  SubscriptionId: string | null;
  EffectiveOnUtc: string | null;
  Reason: string | null;
  InactivationRuleVersion: number | null;
  IpAddress: string | null;
  UserAgent: string | null;
  Details: string | null;
};

/**
 * An audit row with its `Details` parsed, discriminated by `Event`:
 * `if (row.Event === 'InactivationRulesSaved') row.ParsedDetails?.before`.
 * Dates inside `ParsedDetails` are already in the account's wall time, like
 * every `*Utc` field of the row.
 */
export type TAuditEventRow = {
  [K in TAuditEventName]: Omit<TAuditEventView, 'Event'> & {
    Event: K;
    ParsedDetails: TAuditDetailsByEventName[K] | null;
  };
}[TAuditEventName];

/**
 * The screen filters. Every field is optional; an empty one does not filter.
 * `FromDay`/`ToDay` are `yyyy-MM-dd` days in the account's calendar, both
 * inclusive.
 */
export type TAuditEventFilters = {
  FromDay?: string | null;
  ToDay?: string | null;
  UserId?: string | null;
  /** One or more actions; several become an `or` chain (never `in`). */
  Events?: TAuditEventName[] | null;
  Origin?: TAuditOriginName | null;
  PersonId?: string | null;
};

/** One OData page with the total count of the query. */
export type TAuditEventPage = {
  Total: number;
  Items: TAuditEventView[];
};

/** Rows per page on the screen. */
export const AUDIT_EVENTS_PAGE_SIZE = 50;

/** Largest `$top` the set accepts (`EnableQuery(MaxTop = 1000)`): the export page. */
export const AUDIT_EVENTS_MAX_TOP = 1000;
